import { Group } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { ExportExcelButton } from '@/module/Export';

import { AddButtonLink, Browse, usePagination } from '@/core/components';

import { FilterBox, SearchFilter, useSearch, useSortDirection } from '@feature/utils';

import { PatentCard } from './components/Card/PatentCard';
import { getPatentPagedOptions } from './model/PatentQuery';

export function PatentBrowse() {
  const { t } = useTranslation();
  const { sortDirection, toggleSortDirection } = useSortDirection('DESC');
  const { search, searchProps } = useSearch();
  const { pagination, useTotalElements, ...paginationProps } = usePagination({ search });
  const { data } = useSuspenseQuery(
    getPatentPagedOptions({
      ...pagination,
      sortDirection,
      search,
    }),
  );
  useTotalElements(data);

  return (
    <Browse
      actions={
        <Group>
          <ExportExcelButton entityType="patents" />
          <AddButtonLink to="search-claimable" />
        </Group>
      }
      title={t('patents.title')}
      pagination={paginationProps}
      filters={
        <FilterBox>
          <SearchFilter
            label={t('label.search')}
            description={t('patents.searchBy')}
            {...searchProps}
          />
        </FilterBox>
      }
      sortDirection={sortDirection}
      sortedBy={t('patents.sortedBySubmissionYear')}
      toggleSortDirection={toggleSortDirection}
      data={data.list}
      renderItem={patent => (
        <PatentCard
          key={patent.id}
          patent={patent}
          to={`${patent.id}`}
        />
      )}
    />
  );
}
